import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  headerBtn: {
    padding: "2px",
    margin: "0 15px",
    [theme.breakpoints.down("xs")]: {
      margin: "0 8px",
      "& svg": {
        color: "#777",
      },
    },
  },
  popoverList: {
    cursor: "pointer",
    maxWidth: 360,
    padding: 0,
    "& li": {
      padding: "8px 16px",
      "&:last-child": {
        border: "none",
      },
    },
  },
  notifTitle: {
    boxShadow: '0px 1px 3px #00000029',
    padding: "5px 16px",
    "& h6": {
      padding: "6px 0",
    },
  },
  clearBtn: props => {
    const txtColor =
      props.appTheme === "CLASSIC"
        ? theme.palette.primary.main
        : props.appTheme === "LIGHT"
          ? "#777"
          : theme.palette.primary.main;
    return {
      color: txtColor,
    };
  },

  mobileMenuName: {
    margin: "0 0 0 10px",
    paddingLeft: "5px",
    fontSize: 14,
  },
  notifPopover: {
    "& .MuiPopover-paper": {
      overflow: "hidden",
      width: 360,
    },
  },
  vertDivider: {
    color: '#DADADA'
  },
  disableBtn: {
    color: '#CAC3C3 !important',
    pointerEvents: 'none'
  }
}));
